import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { AppService } from './app.service';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ColorPickerModule } from 'ngx-color-picker';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { GridsterModule } from 'angular-gridster2';
import { GridService } from './edit/grid.service';
import { DragulaModule } from 'ng2-dragula';
import { HttpClientModule } from '@angular/common/http';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { NgModule } from '@angular/core';
import { ListComponent } from './list/list.component';
import { ReactiveFormsModule } from '@angular/forms';
import { TinyMceModule } from 'angular-tinymce';
import { ManageContentService } from './manage-content/manage-content.service';
import { NgArrayPipesModule, NgStringPipesModule } from 'angular-pipes';
import { RouterModule } from '@angular/router';
import { DetailsComponent } from './details/details.component';
import { EditComponent } from './edit/edit.component';
import { IconComponent } from './generic/icon/icon.component';
import { LoadingComponent } from './generic/loading/loading.component';
import { ModalComponent } from './generic/modal/modal.component';
import { ManageContentComponent } from './manage-content/manage-content.component';
import { EditPublicationItemComponent } from './manage-content/edit-publication-item/edit-publication-item.component';
import { ContentPanelComponent } from './edit/content-panel/content-panel.component';
import { SectionsPanelComponent } from './edit/sections-panel/sections-panel.component';
import { WriteModalComponent } from './edit/content-panel/integrations/write/write.component';
import { EditSectionModalComponent } from './edit/sections-panel/edit-section-modal/edit-section-modal.component';
import { EditSubsectionModalComponent } from './edit/sections-panel/edit-subsection-modal/edit-subsection-modal.component';
import { EditRssModalComponent } from './edit/content-panel/integrations/rss/edit-modal/edit-modal.component';
import { ContentComponent } from './edit/content-panel/content/content.component';
import { StripHtmlPipe } from './pipes/striphtml';
import { StylesComponent } from './edit/content-panel/styles/styles.component';
import { LayoutComponent } from './edit/content-panel/layout/layout.component';
import { ImagesComponent } from './edit/content-panel/images/images.component';
import { PaletteComponent } from './edit/content-panel/palette/palette.component';
import { SettingsComponent } from './edit/content-panel/settings/settings.component';
import { AutoFocusInputComponent } from './edit/sections-panel/auto-focus-input/auto-focus-input.component';
import { PreviewModalComponent } from './edit/content-panel/integrations/rss/preview-modal/preview-modal.component';
import { EditTwitterModalComponent } from './edit/content-panel/integrations/twitter/edit-modal/edit-modal.component';
import { EditGoogleplusModalComponent } from './edit/content-panel/integrations/googleplus/googleplus.component';
import { TwitterAdvancedSearchModalComponent } from './edit/content-panel/integrations/twitter/advanced-search-modal/advanced-search-modal.component';
import { EditPinterestModalComponent } from './edit/content-panel/integrations/pinterest/pinterest.component';
import { TumblrModalComponent } from './edit/content-panel/integrations/tumblr/tumblr.component';
import { InstagramModalComponent } from './edit/content-panel/integrations/instagram/instagram.component';
import { FlickrModalComponent } from './edit/content-panel/integrations/flickr/flickr.component';
import { FlipbookModalComponent } from './edit/content-panel/integrations/flipbook/flipbook.component';
import { FlipbookOptionsModalComponent } from './edit/content-panel/integrations/flipbook/options/options.component';
import { SlideshareModalComponent } from './edit/content-panel/integrations/slideshare/slideshare.component';
import { YoutubeModalComponent } from './edit/content-panel/integrations/youtube/youtube.component';
import { YoutubeOptionsModalComponent } from './edit/content-panel/integrations/youtube/options/options.component';

@NgModule({
  declarations: [
    AppComponent,
    ListComponent,
    DetailsComponent,
    EditComponent,
    ManageContentComponent,
    EditPublicationItemComponent,
    IconComponent,
    LoadingComponent,
    ModalComponent,
    ContentPanelComponent,
    SectionsPanelComponent,
    WriteModalComponent,
    EditSectionModalComponent,
    EditSubsectionModalComponent,
    EditRssModalComponent,
    ContentComponent,
    StylesComponent,
    LayoutComponent,
    ImagesComponent,
    PaletteComponent,
    SettingsComponent,
    StripHtmlPipe,
    AutoFocusInputComponent,
    PreviewModalComponent,
    EditTwitterModalComponent,
    TwitterAdvancedSearchModalComponent,
    EditGoogleplusModalComponent,
    EditPinterestModalComponent,
    TumblrModalComponent,
    InstagramModalComponent,
    FlickrModalComponent,
    FlipbookModalComponent,
    FlipbookOptionsModalComponent,
    SlideshareModalComponent,
    YoutubeModalComponent,
    YoutubeOptionsModalComponent,
  ],

  imports: [
    AppRoutingModule,
    BrowserAnimationsModule,
    BrowserModule,
    ColorPickerModule,
    FormsModule,
    GridsterModule,
    HttpClientModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatInputModule,
    MatMomentDateModule,
    NgArrayPipesModule,
    NgStringPipesModule,
    ReactiveFormsModule,
    DragulaModule,
    RouterModule,
    TinyMceModule.forRoot({}),
  ],

  providers: [
    AppService,
    ManageContentService,
    GridService,
  ],

  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// /Users/nide/Code/3dissue/3d-issue-hubs-ui/src/app/app.module.ts